/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import request, { ContentType, RequestParams } from './httpClient'
import {
  DomainAdminApp,
  DomainCreateAppReq,
  DomainCreateAppResp,
  DomainUpdateAppReq,
  GetAdminAppDownloadCertParams,
  WebResp,
} from './types'

/**
 * @description 应用列表
 *
 * @tags AdminAppV1
 * @name GetAdminAppList
 * @summary 应用列表
 * @request GET:/api/v1/admin/app
 * @response `200` `(WebResp & {
    data?: (DomainAdminApp)[],

})` OK
 */

export const getAdminAppList = (params: RequestParams = {}) =>
  request<
    WebResp & {
      data?: DomainAdminApp[]
    }
  >({
    path: `/api/v1/admin/app`,
    method: 'GET',
    type: ContentType.Json,
    format: 'json',
    ...params,
  })

/**
 * @description 更新应用
 *
 * @tags AdminAppV1
 * @name PutAdminAppUpdate
 * @summary 更新应用
 * @request PUT:/api/v1/admin/app
 * @response `200` `(WebResp & {
    data?: DomainCreateAppResp,

})` OK
 */

export const putAdminAppUpdate = (req: DomainUpdateAppReq, params: RequestParams = {}) =>
  request<
    WebResp & {
      data?: DomainCreateAppResp
    }
  >({
    path: `/api/v1/admin/app`,
    method: 'PUT',
    body: req,
    type: ContentType.Json,
    format: 'json',
    ...params,
  })

/**
 * @description 创建应用
 *
 * @tags AdminAppV1
 * @name PostAdminAppCreate
 * @summary 创建应用
 * @request POST:/api/v1/admin/app
 * @response `200` `(WebResp & {
    data?: DomainCreateAppResp,

})` OK
 */

export const postAdminAppCreate = (req: DomainCreateAppReq, params: RequestParams = {}) =>
  request<
    WebResp & {
      data?: DomainCreateAppResp
    }
  >({
    path: `/api/v1/admin/app`,
    method: 'POST',
    body: req,
    type: ContentType.Json,
    format: 'json',
    ...params,
  })

/**
 * @description 下载应用证书
 *
 * @tags AdminAppV1
 * @name GetAdminAppDownloadCert
 * @summary 下载应用证书
 * @request GET:/api/v1/admin/app/cert/download
 * @response `200` `(WebResp & {
    data?: (number)[],

})` OK
 */

export const getAdminAppDownloadCert = (query: GetAdminAppDownloadCertParams, params: RequestParams = {}) =>
  request<
    WebResp & {
      data?: number[]
    }
  >({
    path: `/api/v1/admin/app/cert/download`,
    method: 'GET',
    query: query,
    type: ContentType.Json,
    format: 'json',
    ...params,
  })
